import { auth } from '../../utils';
import config from '../../config';

export const checkMfaIssueTokenApi = async () => {
  const userGuid = auth.getAccessToken()?.guid;
  const url = `${config.mfaIssueTokenCheck.baseUrl}${userGuid}/mfa/issue-token`;

  const response = await fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Authorization: `Bearer ${auth.getParsedAuthCookie()?.accessToken}`,
    },
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('No response');
  }
  const json = await response.json();

  return json.Result;
};
